import { parseZonedDateTime } from '@rematter/common/dateTime';

import type { ChatMessageRecord } from '../_types/messageParts';
import { convertGraphQLPartsToTypescript } from '../utils/partConverters';

import { assistantChatMessageFragment } from './fragmentsAssistantChatMessage';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const assistantChatMessagesQueryAtom = createQueryAtomFactory(
  'assistant.chatMessages',
  (params: { chatId: string }) => ({
    assistantChatMessages: {
      __args: { chatId: params.chatId },
      ...assistantChatMessageFragment,
    },
  }),
  {
    select: ({ assistantChatMessages }) => ({
      messages: assistantChatMessages.map(
        (m): ChatMessageRecord => ({
          id: m.id,
          chatId: m.chatId,
          role: m.role as 'User' | 'Assistant' | 'System',
          parts: convertGraphQLPartsToTypescript(m.parts),
          agentId: m.agentId ?? undefined,
          createdAt: parseZonedDateTime(m.createdAt),
        }),
      ),
    }),
  },
);

// Re-export the type for convenience
export type { ChatMessageRecord };
